module.exports = __webpack_public_path__ + "img/shop.a05e28ff.svg";